module.exports = __webpack_public_path__ + "static/media/cobranza.092e7375.png";